import { defineNuxtRouteMiddleware, navigateTo, useRequestURL } from "nuxt/app";
import type { RouteLocationNormalized } from "vue-router";

export default defineNuxtRouteMiddleware((to: RouteLocationNormalized) => {
	const url = useRequestURL();
	const isLocal = url.hostname.includes('local-omnisearch');

	if(to.path.includes('/universities/master') && !isLocal){
		return navigateTo(to.fullPath, {external: true});
	}
})
